/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Campsite } from './Campsite';
import {
    CampsiteFromJSON,
    CampsiteFromJSONTyped,
    CampsiteToJSON,
} from './Campsite';
import type { Metadata } from './Metadata';
import {
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './Metadata';

/**
 * 
 * @export
 * @interface ListCampsitesForMember200Response
 */
export interface ListCampsitesForMember200Response {
    /**
     * 
     * @type {Array<Campsite>}
     * @memberof ListCampsitesForMember200Response
     */
    data: Array<Campsite>;
    /**
     * 
     * @type {Metadata}
     * @memberof ListCampsitesForMember200Response
     */
    metadata: Metadata;
}

/**
 * Check if a given object implements the ListCampsitesForMember200Response interface.
 */
export function instanceOfListCampsitesForMember200Response(value: object): value is ListCampsitesForMember200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function ListCampsitesForMember200ResponseFromJSON(json: any): ListCampsitesForMember200Response {
    return ListCampsitesForMember200ResponseFromJSONTyped(json, false);
}

export function ListCampsitesForMember200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCampsitesForMember200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(CampsiteFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function ListCampsitesForMember200ResponseToJSON(value?: ListCampsitesForMember200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(CampsiteToJSON)),
        'metadata': MetadataToJSON(value['metadata']),
    };
}

